module.exports = __webpack_public_path__ + "static/img/quancheng_06.8489ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quancheng_06.png
// module id = cyAE
// module chunks = 1